/** M5 · Part A — Site operations API + SEO client. */
import { adminApi } from "../api";

export const homepageApi = {
  get: () => adminApi.get(`/admin/homepage`).then(r => r.data),
  saveDraft: (payload) => adminApi.put(`/admin/homepage/draft`, payload).then(r => r.data),
  publish: () => adminApi.post(`/admin/homepage/publish`).then(r => r.data),
  versions: () => adminApi.get(`/admin/homepage/versions`).then(r => r.data),
  rollback: (id) => adminApi.post(`/admin/homepage/rollback/${id}`).then(r => r.data),
};

export const navApi = {
  list: (menu) => adminApi.get(`/admin/navigation`, { params: menu ? { menu } : {} }).then(r => r.data),
  create: (payload) => adminApi.post(`/admin/navigation`, payload).then(r => r.data),
  update: (id, payload) => adminApi.patch(`/admin/navigation/${id}`, payload).then(r => r.data),
  remove: (id) => adminApi.delete(`/admin/navigation/${id}`).then(r => r.data),
  reorder: (items) => adminApi.post(`/admin/navigation/reorder`, items).then(r => r.data),
};

export const redirectsApi = {
  list: () => adminApi.get(`/admin/redirects`).then(r => r.data),
  create: (payload) => adminApi.post(`/admin/redirects`, payload).then(r => r.data),
  update: (id, payload) => adminApi.patch(`/admin/redirects/${id}`, payload).then(r => r.data),
  remove: (id) => adminApi.delete(`/admin/redirects/${id}`).then(r => r.data),
};

export const enquiriesApi = {
  list: (params = {}) => adminApi.get(`/admin/enquiries`, { params }).then(r => r.data),
  counts: () => adminApi.get(`/admin/enquiries/counts`).then(r => r.data),
  get: (id) => adminApi.get(`/admin/enquiries/${id}`).then(r => r.data),
  update: (id, payload) => adminApi.patch(`/admin/enquiries/${id}`, payload).then(r => r.data),
  remove: (id) => adminApi.delete(`/admin/enquiries/${id}`).then(r => r.data),
};

export const settingsApi = {
  get: () => adminApi.get(`/admin/settings`).then(r => r.data),
  update: (payload) => adminApi.patch(`/admin/settings`, payload).then(r => r.data),
  autoresponderPreview: () => adminApi.get(`/admin/settings/autoresponder-preview`).then(r => r.data),
  autoresponderTest: () => adminApi.post(`/admin/settings/autoresponder-test`).then(r => r.data),
};

export const integrationsStatusApi = {
  status: () => adminApi.get(`/admin/integrations/status`).then(r => r.data),
  testEmail: () => adminApi.post(`/admin/integrations/test-email`).then(r => r.data),
};

export const seoApi = {
  audit: (coll, id) => adminApi.get(`/admin/seo/audit/${coll}/${id}`).then(r => r.data),
  dashboard: () => adminApi.get(`/admin/seo/dashboard`).then(r => r.data),
};
